import Seo from '../components/Seo';

const MeetTheTeamPage = () => {
  const founders = [
    {
      name: "Kimaya Ghatwal",
      role: "Chief Executive Officer (CEO)",
      image: "https://customer-assets.emergentagent.com/job_venue-pulse-14/artifacts/ysahfg9x_Screenshot%202026-03-12%20at%202.21.08%E2%80%AFPM.png",
      highlights: [
        "Progressed from active techno community member to event organiser teams",
        "First-hand insight into discovery, logistics, and grassroots challenges",
        "Conducted primary market research shaping Unight's roadmap",
        "Background in clinical psychology informing ethical, behaviour-based discovery",
        "Leads product vision and UK strategic partnerships"
      ]
    },
    {
      name: "Louis Morris",
      role: "Chief Operating Officer (COO) & Creative Lead",
      image: "https://customer-assets.emergentagent.com/job_venue-pulse-14/artifacts/e3v9xd4l_Screenshot%202026-03-12%20at%202.21.33%E2%80%AFPM.png",
      highlights: [
        "Pivotal member of Unight's leadership team with responsibility across strategy, operations, and execution",
        "4+ years of agency experience leading brand, UI/UX, and high-stakes creative execution",
        "Directs Unight's creative roadmap, operational setup, and full visual identity",
        "Translates business objectives into cohesive brand architecture and product strategy",
        "Oversees end-to-end product design, from UI/UX through to final asset delivery"
      ]
    },
    {
      name: "Mithilesh Ghorpade",
      role: "Chief Technology Officer (CTO)",
      image: "https://customer-assets.emergentagent.com/job_venue-pulse-14/artifacts/myn0hljx_Screenshot%202026-03-12%20at%202.21.52%E2%80%AFPM.png",
      highlights: [
        "Neuromarketing PhD researcher with 7 years of marketing leadership",
        "Built enterprise-grade backend systems across live events, retail, and food-tech",
        "Leads scalable, secure platform architecture and data-driven systems",
        "Drives ticketing, analytics, and engagement infrastructure for growth",
        "Expert in AI-driven marketing and consumer behavior analytics"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="team-page">
      <Seo title="Meet the Team" description="The people behind Unight — DJs, promoters, and nightlife obsessives building the UK and India's most curated underground event platform." path="/team" />
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 md:pb-24 overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-900/30 to-transparent" />
        
        <div className="container mx-auto px-4 md:px-8 relative z-10">
          {/* The Team Label */}
          <p className="text-zinc-500 text-lg italic mb-4 opacity-0 animate-fade-in" style={{ animationDelay: '0.1s', animationFillMode: 'forwards' }}>
            The Team
          </p>
          
          {/* Main Title */}
          <h1 
            className="font-['Josefin_Sans'] text-5xl md:text-6xl lg:text-7xl font-bold italic text-white mb-8 opacity-0 animate-fade-in-up tracking-tight"
            style={{ animationDelay: '0.2s', animationFillMode: 'forwards', letterSpacing: '-0.059em' }}
            data-testid="team-title"
          >
            FOUNDERS & VISION
          </h1>
        </div>
      </section>

      {/* Founders Grid - Equal Sizing */}
      <section className="py-12 md:py-16" data-testid="founders-section">
        <div className="container mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
            {founders.map((founder, index) => (
              <div 
                key={founder.name}
                className="opacity-0 animate-fade-in-up"
                style={{ animationDelay: `${0.3 + index * 0.1}s`, animationFillMode: 'forwards' }}
              >
                {/* Photo Card - Equal size for all */}
                <div className="w-full max-w-[320px] mx-auto">
                  {/* Photo */}
                  <div className="aspect-[3/4] bg-zinc-900 overflow-hidden">
                    <img 
                      src={founder.image}
                      alt={founder.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  {/* Name Card - Equal height */}
                  <div className="bg-[#B5FF00] px-4 py-4 text-center h-[80px] flex flex-col justify-center">
                    <h3 className="font-['Josefin_Sans'] text-xl text-black italic font-semibold leading-tight">{founder.name}</h3>
                    <p className="text-black/80 text-xs mt-1 leading-tight">{founder.role}</p>
                  </div>
                </div>

                {/* Highlights - Equal height box */}
                <div className="mt-6 bg-zinc-900/50 border border-zinc-800 p-5 rounded-lg min-h-[280px]">
                  <ul className="space-y-3">
                    {founder.highlights.map((highlight) => (
                      <li 
                        key={highlight.slice(0, 30)}
                        className="flex items-start gap-2 text-zinc-300 text-sm"
                      >
                        <span className="text-[#B5FF00] mt-0.5 flex-shrink-0">•</span>
                        <span className="italic leading-relaxed">{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 border-t border-zinc-800 relative overflow-hidden mt-16">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <span className="footer-brand">UNIGHT</span>
        </div>
        
        <div className="container mx-auto px-4 md:px-8 relative z-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_venue-pulse-14/artifacts/8f7het1z_Unight%202d%20Logos%20%28TM%29-05.png"
              alt="Unight"
              className="h-8"
            />
            <span className="font-mono text-xs text-zinc-600 tracking-widest">
              © 2025 UNIGHT. ALL RIGHTS RESERVED.
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MeetTheTeamPage;
